<template>
  <div class="bc-report-ipr">
    <type-container title="体检事实">
      <pagination-table
        v-for="table in typeTables"
        :key="table.key"
        :title="table.source.title"
        :table-data="table.source.entities"
        :table-props="table.source.props"
        :total="table.source.total"
        :loading="table.source.loading"
        :page-index="table.source.pageIndex"
        :page-size="table.source.pageSize"
        :is-question="table.source.isQuestion"
        :is-page-hand="table.source.pageHand"
        :show-total="table.source.showTotal"
        @pageChanged="tablePageChanged($event, table)"
      />
    </type-container>
    <report-analysis
      type="ipr"
      kind="analysis"
    />
    <report-analysis
      type="ipr"
      kind="suggestion"
    />
  </div>
</template>

<script>
import PaginationTable from '@/components/table/PaginationTable'
import TypeContainer from '@/components/report/ReportTypeContainer'
import ReportAnalysis from './ReportAnalysis'
import mixin from '@/mixins/lawExamReport'
import lawExamProps from '@/service/law-exam/props'

export default {
  name: 'BcReportIpr',
  components: { PaginationTable, ReportAnalysis, TypeContainer },
  mixins: [ mixin ],
  data () {
    return {
      analysis: '公司建立了健全的规章制度管理体系，公司由法律专业人士负责制定的重大规章制度基本涵盖公司经营管理重要环节，且均已向全体员工进行了公示。公司未制定决策管理制度，将直接影响公司经营决策流程及决策效力，甚至将导致纠纷。公司董事、监事、高级管理人员不具备任职资格公司建立了健全的规章制度管理体系，公司由法律专业人士负责制定的重大规章制度基本涵盖公司经营管理重要环节，且均已向全体员工进行了公示。公司未制定决策管理制度，将直接影响公司经营决策流程及决策效力，甚至将导致纠纷。公司董事、监事、高级管理人员不具备任职资格公司建立了健全的规章制度管理体系，公司由法律专业人士负责制定的重大规章制度基本涵盖公司经营管理重要环节，且均已向全体员工进行了公示。公司未制定决策管理制度，将直接影响公司经营决策流程及决策效力，甚至将导致纠纷。公司董事、监事、高级管理人员不具备任职资格公司建立了健全的规章制度管理体系，公司由法律专业人士负责制定的重大规章制度基本涵盖公司经营管理重要环节，\n\n且均已向全体员工进行了公示。公司未制定决策管理制度，将直接影响公司经营决策流程及决策效力，甚至将导致纠纷。公司董事、监事、高级管理人员不具备任职资格公司建立了健全的规章制度管理体系，公司由法律专业人士负责制定的重大规章制度基本涵盖公司经营管理重要环节，且均已向全体员工进行了公示。',
      question: {
        entities: [
          {
            question: '公司董事、监事、高级管理人员（如总经理、副总经理、财务负责人）是否存在兼职情况？',
            answer: '均为兼职'
          }
        ],
        loading: false,
        props: [
          { prop: 'question', className: 'table-highlight-row' },
          { prop: 'answer' }
        ]
      },
      trademark: { ...lawExamProps.trademark },
      copyright: { ...lawExamProps.copyright },
      patent: { ...lawExamProps.patent },
      icp: { ...lawExamProps.icp }
    }
  },
  computed: {
    // 商标 trademark
    // 著作权 copyright
    // 专利 patent
    // 网站备案 icp
    typeTables () {
      return [
        { key: 'queryQA', source: this.queryQA },
        { key: 'trademark', source: this.trademark },
        { key: 'copyright', source: this.copyright },
        { key: 'patent', source: this.patent },
        { key: 'icp', source: this.icp }
      ]
    }
  },
  created () {
    this.queryQA.type = 4
  }
}
</script>
